// JsaPermitInfo
export class JsaPermitInfo {
  constructor(data = {}) {
    this.safeWorkPermit = data.safe_work_permit || false;
    this.hotWorkPermit = data.hot_work_permit || false;
    this.confinedSpacePermit = data.confined_space_permit || false;
    this.excavationPermit = data.excavation_permit || false;
    this.lockoutTagoutPermit = data.lockout_tagout || false;
    this.otherPermit = data.other_permit || false;
    this.otherPermitInfo = data.other_permit_info || "";
  }

  updateSafeWorkPermit(value) {
    this.safeWorkPermit = value;
  }

  updateHotWorkPermit(value) {
    this.hotWorkPermit = value;
  }

  updateConfinedSpacePermit(value) {
    this.confinedSpacePermit = value;
  }

  updateExcavationPermit(value) {
    this.excavationPermit = value;
  }

  updateLockoutTagoutPermit(value) {
    this.lockoutTagoutPermit = value;
  }

  updateOtherPermit(value) {
    this.otherPermit = value;
  }

  updateOtherPermitInfo(value) {
    this.otherPermitInfo = value;
  }

  // To json for sending to the database
  toJson() {
    return {
      safe_work_permit: this.safeWorkPermit,
      hot_work_permit: this.hotWorkPermit,
      confined_space_permit: this.confinedSpacePermit,
      excavation_permit: this.excavationPermit,
      lockout_tagout: this.lockoutTagoutPermit,
      other_permit: this.otherPermit,
      other_permit_info: this.otherPermitInfo,
    };
  }

  // Helper for single and multi-field patches to be sent via websocket
  toPatch(fields, jsaId, action = "update") {
    const fieldMap = {
      safeWorkPermit: "safe_work_permit",
      hotWorkPermit: "hot_work_permit",
      confinedSpacePermit: "confined_space_permit",
      excavationPermit: "excavation_permit",
      lockoutTagoutPermit: "lockout_tagout",
      otherPermit: "other_permit",
      otherPermitInfo: "other_permit_info",
    };

    const patch = {
      patch_type: "jsa_permit_info",
      jsa_id: jsaId,
      action,
    };

    for (const [key, value] of Object.entries(fields)) {
      const dbField = fieldMap[key];
      if (dbField) {
        patch[dbField] = value;
      }
    }

    return patch;
  }
}
